import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function BushaLoader() {
  return (
    <DotLottieReact
      style={{ height: 120, width: 120 }}
      src={"/lotties/appicon.json"}
      loop
      autoplay
    />
  );
}
